"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
var React = require("react");
var common_1 = require("docs/common");
var components_1 = require("components");
var componentStyle = {
    base: {
        width: 200,
        height: 200,
    },
};
var description = 'This is how you get Paper if you don\'t pass any properties.' +
    ' It has an AppBar, a DSimpleer and a PaperBody, that has a gray background color.' +
    ' You can click on default button to toggle the dSimpleer.';
var code = "import React from 'react';\nimport { Paper } from 'jsc-react-ui';\n\nconst Example = () => <Paper />;";
exports.SimpleExamplePaper = function () { return (React.createElement(common_1.Example, { title: "Simple", description: description, code: code },
    React.createElement(components_1.Paper, { style: componentStyle.base }))); };
exports.SimpleExamplePaper.displayName = 'SimpleExamplePaper';



//////////////////
// WEBPACK FOOTER
// ./src/docs/pages/ComponentPaperPage/SimpleExamplePaper.tsx
// module id = 695
// module chunks = 0